class Sprite {
  constructor(obj) {
    const { element, frameElement, countFrames, dimensions, size } = obj;

    this.el = jQuery(element);
    this.frameElement = frameElement || this.el.find(".s-custom-parallax__frame");
    this.countFrames = countFrames || 10;
    this.dim = dimensions || { width: 100, height: 100 };
    this.size = size || 100;

    this._setElementSize(this.dim);
  }

  _setElementSize(dim) {
    this.el.css({
      width: dim.width,
      height: dim.height,
    });
  }

  goto(frame) {
    if(frame<0) frame = 0
    if(frame>this.countFrames) frame = this.countFrames
    
    this._move(frame);
  }

  _move(frame) {
    this.frameElement.css("transform", `translateY(-${frame * this.size}px)`);
  }
}export default Sprite;
